import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment-timezone';
import _ from 'lodash';
import { RenderField, RenderSubmitButton, RenderHiddenField } from './common/form';
import { signup, checkEmail } from '../actions/AuthActions';
import FacebookLoginButton from './common/auth/FacebookLoginButton';
import * as Validations from './common/form/commonValidations';
import { trackOnboardingStarted } from '../util/trackingHelper';

const trackOnboardingStartedOnce = _.once(trackOnboardingStarted);

class SignupForm extends Component {

  constructor(props) {
    super(props);

    this.handleError = this.handleError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      error: false,
      errorMessage: ''
    };
  }

  onSubmit(values) {
    const { handleSubmit } = this.props;
    this.setState({ error: false });
    const submitReturn = handleSubmit(values);
    if (submitReturn.catch) submitReturn.catch(this.handleError);
  }

  handleError(error) {
    this.setState({ error: true, errorMessage: error.detailedMessage });
  }

  render() {
    const { onFacebookSuccess, setAuthState, pristine, submitting } = this.props;
    const { error, errorMessage } = this.state;

    trackOnboardingStartedOnce('WEDDINGS', 'WEDDINGS', false);

    return (
      <div>
        <div className="modal-header">
          <div className="zola-weddings-logo-black-100 center-block" />
          <h3 className="text-center">
            The Heart Of Your Wedding
          </h3>
        </div>
        <div className="modal-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                <FacebookLoginButton callback={onFacebookSuccess} errorCallback={this.handleError} />
                <div className="h4 text-with-line"><span>or</span></div>
                <form onSubmit={this.onSubmit}>
                  <Field
                    name="email"
                    type="email"
                    label="Email"
                    placeholder="Email"
                    id="signup-email"
                    component={RenderField}
                    required
                    validate={[Validations.REQUIRED, Validations.EMAIL]}
                  />
                  <Field
                    name="password"
                    id="signup-password"
                    label="Password"
                    type="password"
                    component={RenderField}
                    placeholder="Password (8 or more characters)"
                    required
                    validate={[Validations.REQUIRED, Validations.PASSWORD]}
                  />
                  <Field
                    name="timezone"
                    id="signup-timezone"
                    component={RenderHiddenField}
                  />
                  <RenderSubmitButton pristine={pristine} submitting={submitting} valid value="Sign Up For Free" className="btn-block btn-primary btn btn-lg" />
                  <div className="clearfix" />
                  {error &&
                  <div className="form-message-block text-center text-danger">
                    {errorMessage || 'There was a problem processing your request. Please try again or contact customer support for assistance.'}<br /><br /></div>
                  }
                  <div className="text-muted text-center form-message-block">
                    By creating your Zola account you agree to our
                    <br className="hidden-xs" />
                    <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="text-center">Already a member? <a role="button" onClick={() => setAuthState('login')}>Log In</a><br /><br /></div>
        </div>
      </div>
    );
  }
}

SignupForm.propTypes = {
  onFacebookSuccess: PropTypes.func.isRequired,
  setAuthState: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  // selectedThemeId: PropTypes.number
};

const mapStateToProps = () => (
  {
    initialValues: {
      timezone: moment.tz.guess()
    },
    asyncBlurFields: ['email']
  }
);

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    asyncValidate: ({ email }) => dispatch(checkEmail(email)).then((json) => {
      if (!json.is_available) {
        const error = { email: 'This email address is taken.' };
        throw error;
      }
    }),
    onSubmit: createUserRequest => dispatch(signup(createUserRequest)).then(ownProps.onSignupSuccess)
    // on submit for creating a wedding? or is the theme a part of the user request already?
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'SignupForm',
  enableReinitialize: true
})(SignupForm));



// WEBPACK FOOTER //
// ./src/components/SignupForm.jsx